import {
	CommunicationsResponseModel,
	ProviderDetails,
} from 'domain/usecases/private/communications/get-communications';
import {formatAddress} from './formatAddress';

const mapProvider = (provider: ProviderDetails): ProviderDetails => ({
	...provider,
	formattedAddress: formatAddress(provider),
});

const mapCommunicationsData = (
	communications: CommunicationsResponseModel,
): CommunicationsResponseModel =>
	(communications ?? []).map(item => ({
		...item,
		prestadorAtual: item.prestadorAtual ? mapProvider(item.prestadorAtual) : undefined,
		prestadorSubstituto: item.prestadorSubstituto
			? mapProvider(item.prestadorSubstituto)
			: undefined,
	}));

export {mapCommunicationsData};
